import { telemetryToClickAttributes } from '@modules/prism-client/lib/telemetry';
import { TextButton as WebCompositionsTextButton } from '@tuic/web-compositions/core/TextButton';

import { Link } from './Link';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { TextButtonProps as WebCompositionsTextButtonProps } from '@tuic/web-compositions/core/TextButton';
import type { FC } from 'react';

type Props = WebCompositionsTextButtonProps & {
  data: PrismAPI.TextButton;
};

export const TextButton: FC<Props> = props => {
  return (
    <WebCompositionsTextButton {...apiTextButtonToTextButtonProps(props)} />
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- props mapper co-located with its component
export const apiTextButtonToTextButtonProps = ({
  data,
  ...props
}: Props): WebCompositionsTextButtonProps => {
  const children = data.link ? (
    <Link data={data.link}>{props.children ?? data.label}</Link>
  ) : (
    (props.children ?? data.label)
  );

  return {
    ...telemetryToClickAttributes(data.telemetry),
    ...props,
    iconLeft: (data.iconLeft ??
      props.iconLeft) as WebCompositionsTextButtonProps['iconLeft'],
    iconRight: (data.iconRight ??
      props.iconRight) as WebCompositionsTextButtonProps['iconRight'],
    iconSize: data.iconSize ?? props.iconSize,
    size: data.size ?? props.size,
    on: data.on ?? props.on,
    asChild: props.asChild ?? !!data.link,
    children,
  };
};
